/* ═══ A COR VAI NO MODELO, NÃO NUMA FOTO — [2026-08-18] ══════════════════════
   Ele: *"pensei em montar as cores pelo 3D do objeto, sem foto"*.

   🔑 O MODELO JÁ VEM COM AS DUAS PARTES SEPARADAS. Medido no glb: materiais
     `ABS_(Branco)` (base) e `Cupula_acende` (cúpula). Pinto pelo NOME, com
     reserva pela ordem — nome some quando alguém reexporta do Fusion, e aí a
     página não pode parar de funcionar por causa de uma string.

   ⚠️ A CÚPULA TEM DOIS CANAIS DE COR. `baseColorFactor` é a peça apagada;
     `emissiveFactor` é a luz que ela emite. Trocando só o primeiro, a peça
     fica da cor nova apagada e da cor VELHA acesa — e é acesa que ela é
     fotografada e vendida.

   🪤 `model-viewer` SÓ TEM `model` DEPOIS DO EVENTO `load`. Pintar antes não
     erra: não faz nada, em silêncio.
*/
(function () {
  'use strict';
  var raiz = document.querySelector('[data-monte]');
  if (!raiz) return;

  var mv = raiz.querySelector('[data-mv]');
  /* o estúdio está ligado? decide qual par de exposições vale — 0.72/0.85 é
     calibrado PARA o estúdio; em `neutral` os números certos são os antigos */
  function estudio() { return (mv.getAttribute('environment-image') || 'neutral') !== 'neutral'; }
  var escolha = { cupula: null, base: null, tam: null };
  var aceso = false;

  /* ── hex → array linear que o glTF espera ──
     🪤 A COR DA TELA NÃO É A COR DO glTF. O hex vem em sRGB e o
       `baseColorFactor` é LINEAR: passando o valor cru, toda cor sai lavada,
       clara demais — parece erro de escolha de paleta e é matemática. */
  function paraLinear(hex) {
    var h = (hex || '').replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return [1, 1, 1, 1];
    return [ (n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255 ].map(function (c) {
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }).concat([1]);
  }

  function acha(qual) {
    var mats = (mv.model && mv.model.materials) || [];
    if (!mats.length) return null;
    for (var i = 0; i < mats.length; i++) {
      var nome = (mats[i].name || '').toLowerCase();
      if (qual === 'cupula' && (nome.indexOf('cupula') > -1 || nome.indexOf('cúpula') > -1 || nome.indexOf('acende') > -1)) return mats[i];
      if (qual === 'base' && (nome.indexOf('abs') > -1 || nome.indexOf('base') > -1)) return mats[i];
    }
    /* reserva pela ordem: no glb a cúpula é a primeira e a base a segunda */
    return qual === 'cupula' ? mats[0] : (mats[1] || mats[0]);
  }

  function pinta(qual, hex) {
    var m = acha(qual);
    if (!m) return;
    var cor = paraLinear(hex);
    try { m.pbrMetallicRoughness.setBaseColorFactor(cor); } catch (e) {}

    /* ═══ O ACABAMENTO, QUE É O QUE FAZ PARECER PEÇA E NÃO PLÁSTICO ═══
       🔑 PLA IMPRESSO NÃO BRILHA E NÃO É METAL. O glTF sai do Fusion com
         valores de CAD — metallic alto e roughness baixa dão aquele plástico
         de renderização, brilhante e duro. Fosco (roughness .82) e metal zero
         é o que se parece com a peça na mão.
       ⚠️ A CÚPULA É MENOS FOSCA QUE A BASE, de propósito: ela é fina e passa
         luz, então tem um brilho de borda que a base maciça não tem. Sem essa
         diferença as duas partes parecem o mesmo bloco pintado. */
    try {
      var aspero = qual === 'cupula' ? 0.62 : 0.82;
      m.pbrMetallicRoughness.setRoughnessFactor(aspero);
      m.pbrMetallicRoughness.setMetallicFactor(0);
    } catch (e) {}

    if (qual === 'cupula') {
      /* a luz acompanha a cor da peça, senão acende na cor antiga.
         ⚠️ APAGADA ELA NÃO FICA EM ZERO: um resto de emissão (12%) é o que
           faz a cúpula parecer TRANSLÚCIDA em vez de um casco opaco. Peça
           apagada e peça de plástico maciço não têm a mesma cara.
         ⚠️ 5% E NÃO 12%: na foto do render, 12% somava luz à cor e o Caramelo
           Soft saía laranja forte — a pessoa escolheria uma cor e receberia
           outra, que é o pior defeito possível numa página de personalizar. */
      var brilho = aceso ? 1 : 0.05;
      try { m.setEmissiveFactor([cor[0] * brilho, cor[1] * brilho, cor[2] * brilho]); } catch (e) {}
    }
  }

  /* uma leitura só do tamanho, usada na partida e no clique — duas leituras
     divergentes já foi a origem de defeito neste arquivo */
  function leTam(el) {
    return { nome: el.querySelector('b') ? el.querySelector('b').textContent : '',
             preco: el.dataset.preco, handle: el.dataset.handle, modelo: el.dataset.modelo,
             usdz: el.dataset.usdz, variante: el.dataset.variante, medida: el.dataset.medida,
             pix: el.dataset.pix, parc: el.dataset.parc, cash: el.dataset.cash };
  }

  /* ═══ O QUE VAI PARA O CARRINHO ═══════════════════════════════════════════
     🔑 O FORM É A VERDADE, não uma cópia do estado. Escrevo a escolha nos
       campos escondidos a cada mudança; assim, se o JS da gaveta falhar e o
       navegador enviar o form do jeito nativo, o pedido sai CERTO do mesmo
       jeito. Estado que só existe em memória some no primeiro tropeço.
     🪤 SEM VARIANTE, O BOTÃO SE DESLIGA — não fica esperando o clique para
       falhar. Enquanto a peça personalizada estiver em rascunho não existe
       variante nenhuma, e botão que existe e não responde é pior que botão
       desligado: a pessoa clica, nada acontece, e ela conclui que a loja está
       quebrada. */
  function sincronizaForm() {
    var f = raiz.querySelector('[data-form]');
    if (!f) return;
    var id = escolha.tam && escolha.tam.variante;
    var campo = f.querySelector('[data-campo-variante]');
    if (campo) campo.value = id || '';
    var põe = function (qual, valor) {
      var c = f.querySelector('[data-prop="' + qual + '"]');
      if (c) c.value = valor || '';
    };
    põe('cupula', escolha.cupula && escolha.cupula.nome);
    põe('base', escolha.base && escolha.base.nome);
    põe('altura', escolha.tam && escolha.tam.medida);

    var bt = f.querySelector('[data-comprar]');
    var rot = f.querySelector('[data-rotulo]');
    if (bt) {
      bt.disabled = !id;
      if (rot) rot.textContent = id ? bt.dataset.rotulo : (bt.dataset.rotuloOff || 'INDISPONÍVEL');
    }
  }

  function repinta() {
    if (escolha.cupula) pinta('cupula', escolha.cupula.hex);
    if (escolha.base) pinta('base', escolha.base.hex);
    halo();
  }

  /* 🔑 O BRILHO QUE VAZA É A COR DA CÚPULA MISTURADA COM A DA LÂMPADA. Luz
     branca saindo de uma cúpula Rosa Marshmallow não existe — e luz da cor
     pura da cúpula também não: lâmpada é quente. A mistura é o que se vê. */
  function halo() {
    var el = raiz.querySelector('[data-halo]');
    var viz = raiz.querySelector('[data-viz]');
    var hex = (escolha.cupula && escolha.cupula.hex) || '#ffd9a8';
    var quente = misturaQuente(hex);
    if (el) el.style.setProperty('--halo', quente);
    /* a luz que bate no ambiente é a mesma que sai da cúpula — se fossem duas
       cores, a cena se contradiria */
    if (viz) viz.style.setProperty('--luz', quente);
  }

  function misturaQuente(hex) {
    var h = (hex || '').replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return '#ffd9a8';
    var q = [255, 217, 168];   /* #ffd9a8, a mesma luz do ColiWorks */
    var r = [(n >> 16 & 255), (n >> 8 & 255), (n & 255)].map(function (c, i) {
      return Math.round(c * 0.45 + q[i] * 0.55);
    });
    return 'rgb(' + r.join(',') + ')';
  }

  /* ═══ O RESUMO É O ESTADO DO APLICATIVO ═════════════════════════════════
     🔑 A BARRA MOSTRA O QUE ESTÁ MONTADO, SEMPRE. Num configurador a pessoa
       rola, troca, volta — e sem um lugar fixo dizendo "é isto que você vai
       levar, por tanto" ela perde o fio. É o que separa um app de uma página
       com opções soltas.
     🔑 E A BOLINHA É O RESUMO MAIS CURTO POSSÍVEL: metade de cima com a cor da
       cúpula, metade de baixo com a da base. Cabe onde texto não cabe. */
  function resumo() {
    var el = raiz.querySelector('[data-resumo]');
    var tt = raiz.querySelector('[data-resumo-tam]');
    var pf = raiz.querySelector('[data-preco-fim]');
    var mini = raiz.querySelector('[data-mini]');

    if (tt) tt.textContent = escolha.tam ? escolha.tam.nome : '';
    if (el) {
      el.textContent = [
        escolha.cupula ? 'cúpula ' + escolha.cupula.nome : '',
        escolha.base ? 'base ' + escolha.base.nome : ''
      ].filter(Boolean).join(' · ');
    }
    if (pf && escolha.tam) pf.textContent = escolha.tam.preco || '';

    /* 🔑 A OFERTA ACOMPANHA O TAMANHO. Pix, parcela e cashback são frações do
       preço, e o preço muda com a peça — deixar fixo faria a página prometer
       o valor do Pequeno para quem escolheu o Super. Os três já vêm calculados
       do Liquid no botão do tamanho; aqui é só copiar. */
    if (escolha.tam) {
      /* 🪤 O SELETOR PRECISA DO ESCOPO. `data-pix` existe em DOIS lugares — no
         botão do tamanho (onde o Liquid guarda o valor) e no <b> da oferta
         (onde ele é mostrado). Sem `.mt-oferta` na frente, o `querySelector`
         pega o PRIMEIRO do documento, que é o botão, e escreve o preço por
         cima do conteúdo dele. Segunda vez que caio nisto hoje: o mesmo já
         tinha acontecido com `data-variante`, e ali resolvi renomeando.
         Aqui o escopo é mais honesto — o nome descreve o dado, e quem diz
         qual dos dois é o lugar. */
      [['[data-pix]', 'pix'], ['[data-parc]', 'parc'], ['[data-cash]', 'cash']].forEach(function (par) {
        var el = raiz.querySelector('.mt-oferta ' + par[0]);
        if (el && escolha.tam[par[1]]) el.textContent = escolha.tam[par[1]];
      });
    }
    if (mini) {
      if (escolha.cupula) mini.style.setProperty('--mc', escolha.cupula.hex);
      if (escolha.base) mini.style.setProperty('--mb', escolha.base.hex);
    }
    sincronizaForm();
    var nc = raiz.querySelector('[data-nome-cupula]');
    var nb = raiz.querySelector('[data-nome-base]');
    if (nc && escolha.cupula) nc.textContent = '— ' + escolha.cupula.nome;
    if (nb && escolha.base) nb.textContent = '— ' + escolha.base.nome;
  }

  /* ═══ OS PASSOS, QUE SÃO NAVEGAÇÃO E NÃO ENFEITE ═══════════════════════════
     🔑 Clicar no passo LEVA até ele: quem já escolheu o tamanho e quer trocar
       só a base clica no 3 e vai. Indicador que só indica é desenho; este
       anda. E o passo se marca sozinho conforme a pessoa rola — senão o
       cabeçalho mentiria enquanto ela desce. */
  var passos = [].slice.call(raiz.querySelectorAll('[data-passo]'));
  var abas = [].slice.call(raiz.querySelectorAll('.mt-p'));

  function marcaPasso(n) {
    abas.forEach(function (a, i) {
      var atual = String(i + 1) === String(n);
      a.classList.toggle('on', atual);
      a.classList.toggle('feito', i + 1 < Number(n));
      /* diz onde a pessoa está para quem não enxerga o trilho */
      if (atual) a.setAttribute('aria-current', 'step');
      else a.removeAttribute('aria-current');
    });
    var tr = raiz.querySelector('[data-trilho]');
    if (tr) tr.style.transform = 'scaleY(' + (Number(n) / abas.length) + ')';  /* transform, não width: ver ettore-frete.js */
  }

  abas.forEach(function (a) {
    a.addEventListener('click', function () {
      var n = a.dataset.ir;
      var alvo = raiz.querySelector('[data-passo="' + n + '"]');
      if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      marcaPasso(n);
    });
  });

  /* 🪤 O OBSERVADOR PRECISA DE UMA FAIXA ESTREITA NO MEIO DA TELA. Com o
     padrão, dois passos ficam visíveis ao mesmo tempo e o indicador pisca
     entre eles enquanto a pessoa rola. */
  if (window.IntersectionObserver && passos.length) {
    var obs = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (e.isIntersecting) marcaPasso(e.target.dataset.passo);
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    passos.forEach(function (p) { obs.observe(p); });
  }

  /* ── o que está escolhido, lido da marcação ── */
  function leInicial() {
    ['cupula', 'base'].forEach(function (qual) {
      var cx = raiz.querySelector('[data-cores="' + qual + '"]');
      var on = cx && (cx.querySelector('.mt-cor.on') || cx.querySelector('.mt-cor'));
      if (on) escolha[qual] = { hex: on.dataset.cor, nome: on.dataset.nome };
    });
    var t = raiz.querySelector('.mt-tam.on') || raiz.querySelector('.mt-tam');
    if (t) escolha.tam = leTam(t);
  }

  /* ═══ O AMBIENTE ENTRA CONFERIDO, NUNCA NA MARCAÇÃO — [2026-08-18] ════════
     🪤 O model-viewer ESPERA O AMBIENTE ANTES DE MOSTRAR O MODELO, e não
       degrada: se o .hdr falhar, o canvas fica VAZIO — sem erro, sem peça.
     🪤 E NÃO DÁ PARA CONSERTAR DEPOIS. Tentei o guarda óbvio: seis segundos
       sem `loaded`, volta para `neutral` e repõe o `src`. MEDIDO com o arquivo
       quebrado de três jeitos (404, bytes inválidos, requisição pendurada
       para sempre): nos TRÊS a peça continuou ausente aos 25 s, com o
       ambiente já em `neutral`. A cadeia que espera o ambiente não se desfaz.
     🔑 ENTÃO A ORDEM SE INVERTE: a marcação NÃO traz `environment-image`, e o
       model-viewer nasce em `neutral`, que é interno e não pede rede — a peça
       aparece de qualquer jeito. O estúdio só é ligado depois que estes bytes
       chegaram e foram CONFERIDOS aqui. Falhando, nada acontece: fica plana,
       que é infinitamente melhor que ausente.
     🔑 E NÃO PISCA, porque a busca começa junto com a do modelo, não depois:
       quando a peça aparece, o .hdr já está no cache do navegador e trocar o
       atributo é instantâneo. Medido: 0 ms de segunda descida.
     ⚠️ CONFERIR É LER A ASSINATURA, não só o status. Um 200 com HTML de erro
       passa no `r.ok` e engasga o leitor do mesmo jeito — arquivo Radiance
       começa em `#?RADIANCE`. */
  (function () {
    var url = mv.getAttribute('data-ambiente');
    if (!url || !window.fetch) return;
    var corta = window.AbortController ? new AbortController() : null;
    if (corta) setTimeout(function () { corta.abort(); }, 8000);
    fetch(url, corta ? { signal: corta.signal } : undefined)
      .then(function (r) { if (!r.ok) throw 0; return r.arrayBuffer(); })
      .then(function (buf) {
        var assinatura = String.fromCharCode.apply(null, new Uint8Array(buf, 0, 10));
        if (assinatura.indexOf('#?RADIANCE') !== 0) throw 0;
        mv.setAttribute('environment-image', url);
        mv.setAttribute('exposure', aceso ? '0.85' : '0.72');
      })
      .catch(function () { /* fica em neutral, de propósito */ });
  })();

  mv.addEventListener('load', repinta);

  raiz.addEventListener('click', function (e) {
    var cor = e.target.closest('.mt-cor');
    if (cor) {
      var cx = cor.closest('[data-cores]');
      var qual = cx.dataset.cores;
      /* 🔑 A CLASSE É PARA O OLHO, O `aria-pressed` É PARA O OUVIDO. Mexer só
         na classe deixava o leitor de tela dizendo "não pressionado" nos doze
         botões, para sempre. Os dois andam juntos, sempre. */
      cx.querySelectorAll('.mt-cor').forEach(function (b) {
        b.classList.remove('on'); b.setAttribute('aria-pressed', 'false');
      });
      cor.classList.add('on'); cor.setAttribute('aria-pressed', 'true');
      escolha[qual] = { hex: cor.dataset.cor, nome: cor.dataset.nome };
      pinta(qual, cor.dataset.cor);
      resumo();
      return;
    }

    var tam = e.target.closest('.mt-tam');
    if (tam) {
      raiz.querySelectorAll('.mt-tam').forEach(function (b) {
        b.classList.remove('on'); b.setAttribute('aria-pressed', 'false');
      });
      tam.classList.add('on'); tam.setAttribute('aria-pressed', 'true');
      escolha.tam = leTam(tam);
      /* 🪤 TROCAR O MODELO APAGA A PINTURA: o `load` do novo arquivo traz os
         materiais originais. Por isso `repinta` está pendurado no evento, e
         não chamado aqui — chamando aqui, pintaria o modelo ANTIGO. */
      if (tam.dataset.modelo && mv.getAttribute('src') !== tam.dataset.modelo) {
        mv.setAttribute('src', tam.dataset.modelo);
        /* o arquivo do iPhone acompanha o tamanho: senão a câmera abriria
           sempre a mesma peça, qualquer que fosse a escolhida */
        if (tam.dataset.usdz) mv.setAttribute('ios-src', tam.dataset.usdz);
      }
      resumo();
      return;
    }

    var luz = e.target.closest('[data-luz]');
    if (luz) {
      aceso = !aceso;
      luz.setAttribute('aria-pressed', aceso ? 'true' : 'false');
      var rot = luz.querySelector('span');
      if (rot) rot.textContent = aceso ? 'Apagar' : 'Acender';
      /* 🔑 ACENDER É ESCURECER A CENA, e é o que o ColiWorks faz com o modo
         noite. Luz acesa em palco claro não aparece — a peça só vira
         luminária quando o resto baixa. */
      var viz = raiz.querySelector('[data-viz]') || mv.parentElement;
      viz.classList.toggle('noite', aceso);
      /* 🪤 ACESA A EXPOSIÇÃO NÃO CAI, SOBE UM POUCO. Baixá-la era o modo noite
         que ele reprovou: escurecia a peça inteira para o brilho aparecer. Se
         o ambiente é que se ilumina, a peça tem de continuar legível — quem
         está escolhendo cor precisa ver a cor. */
      /* 🔁 OS DOIS NÚMEROS SUBIRAM DE BASE em 18/08, com o estúdio: o apagado
         passou de 0.8 para 0.72 porque é aí que a peça sai da cor da bolinha
         (distância média 3,5 contra 13,3). O aceso mantém a mesma diferença de
         +0,13 — o que ele aprovou foi a RELAÇÃO entre os dois, não os valores. */
      mv.setAttribute('exposure', estudio() ? (aceso ? '0.85' : '0.72') : (aceso ? '0.95' : '0.8'));
      repinta();
      return;
    }

  });

  /* 🪤 O `ios-src` VAI POR setAttribute, NUNCA POR PROPRIEDADE. É a armadilha
     já registrada no visualizador: `model-viewer` é custom element carregado
     por módulo assíncrono, e escrever `mv.iosSrc = …` antes do upgrade cria um
     campo comum que o componente sobrescreve — o arquivo nunca carrega e o
     botão da câmera não abre no iPhone, sem erro nenhum. */
  var usdz = mv.getAttribute('data-usdz');
  if (usdz) mv.setAttribute('ios-src', usdz);

  /* 🪤 O BOTÃO DO SLOT NÃO SE ESCONDE SOZINHO. O model-viewer esconde o botão
     PADRÃO dele quando o aparelho não tem AR, mas um botão nosso no
     `slot="ar-button"` fica visível em qualquer lugar — medido: aparecia no
     Chrome de mesa, onde clicar não faz absolutamente nada. Botão que existe
     e não responde é pior que botão ausente.
     🔑 QUEM DECIDE É `canActivateAR`, não o user-agent: detectar "é celular"
       na mão erra nos dois sentidos — iPad sem AR e desktop com WebXR. */
  var btAr = mv.querySelector('[slot="ar-button"]');
  if (btAr) {
    btAr.style.display = 'none';
    var mostra = function () { if (mv.canActivateAR) btAr.style.display = ''; };
    mv.addEventListener('load', mostra);
    setTimeout(mostra, 1200);
  }

  /* ═══ ADICIONAR ABRE A GAVETA, NÃO TROCA DE PÁGINA ═══════════════════════
     Mesma receita da `ettore-produto`, e de propósito: uma página que compra
     de um jeito diferente das outras é uma página que quebra sozinha quando
     alguém mexe no carrinho.
     🪤 QUEM ENVIOU O FORM É `e.submitter`, não `document.activeElement`. Já
       registrado na página de produto: o Safari não dá foco a botão no clique,
       e com `activeElement` o "adicionar" recarregava a página de forma
       intermitente — o pior tipo de defeito.
     🔑 FALHANDO QUALQUER COISA, CAI NO ENVIO NATIVO (`form.submit()`). A pessoa
       vai parar na página do carrinho em vez da gaveta, que é pior de
       experiência e melhor que perder a venda. */
  var form = raiz.querySelector('[data-form]');
  if (form) form.addEventListener('submit', function (e) {
    var quem = e.submitter || document.activeElement;
    if (!quem || quem.name !== 'add') return;
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta || typeof gaveta.open !== 'function') return;   /* sem gaveta, caminho normal */

    e.preventDefault();
    quem.disabled = true;
    var raizLoja = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* 🪤 DUAS FALHAS DIFERENTES, DOIS CAMINHOS. Cair no envio nativo é a saída
       certa para falha de REDE — o navegador tenta de novo pelo caminho normal
       e a venda se salva. Mas é a saída ERRADA para a loja RECUSANDO o item
       (422): o envio nativo leva a pessoa para a página de erro da Shopify,
       em inglês, sem volta. Medido em 18/08: variante de produto em rascunho
       devolve 422 "Impossível encontrar variante". Aí o certo é dizer o que
       houve, no próprio botão, e deixar a pessoa na página. */
    fetch(raizLoja + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) {
          if (r.ok) return j;
          var e = new Error('recusado'); e.recusado = true;
          e.msg = (j && (j.description || j.message)) || '';
          throw e;
        });
      })
      .then(function () {
        quem.disabled = false;
        /* 🪤 ABRIR NÃO REDESENHA. Eu tinha copiado o par
           `dispatchEvent('cart:refresh')` + `gaveta.open()` da página de
           produto, e MEDI o resultado: a gaveta abriu dizendo "Seu carrinho
           está vazio" enquanto o `/cart.js` já respondia 1 item. O
           `cart:refresh` é a SAÍDA do `redesenha()` — quem escuta é o contador
           da sacola no cabeçalho —, não a entrada. Quem repinta a gaveta pelo
           Liquid é `redesenha()`, e só ele.
           🔑 E ele já dispara o `cart:refresh` sozinho no fim: disparar aqui
              também contaria o evento duas vezes, que é defeito já registrado
              neste projeto em outro lugar. */
        var pronto = (typeof gaveta.redesenha === 'function')
          ? gaveta.redesenha()
          : Promise.resolve();
        return pronto.then(function () { gaveta.open(quem); });
      })
      .catch(function (err) {
        quem.disabled = false;
        if (!err || !err.recusado) { form.submit(); return; }
        var rot = form.querySelector('[data-rotulo]');
        if (!rot) return;
        var antes = rot.textContent;
        rot.textContent = err.msg || 'NÃO FOI POSSÍVEL ADICIONAR';
        form.classList.add('recusado');
        setTimeout(function () { rot.textContent = antes; form.classList.remove('recusado'); }, 4000);
      });
  });

  /* os dois rótulos ficam guardados no próprio botão: o de comprar e o de
     indisponível. Ler do DOM evita repetir o texto do editor dentro do JS. */
  (function () {
    var bt = raiz.querySelector('[data-comprar]');
    var rot = raiz.querySelector('[data-rotulo]');
    if (bt && rot) { bt.dataset.rotulo = rot.textContent.trim(); }
  })();

  leInicial();
  resumo();
  /* o trilho nasce no passo 1: sem isto ele fica vazio até o primeiro toque,
     e o cabeçalho abre dizendo menos do que sabe */
  marcaPasso(1);
})();
